// Updates all page links so internal URLs use the same tab,
// while external URLs open in a new tab with safe rel attributes.
(function () {

  const internalDomains = [
    "affordablegolf.co.uk",
    "www.affordablegolf.co.uk"
  ];

  function updateLinks() {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');

      // Skip special links
      if (
        !href ||
          href.startsWith('#') ||
          href.startsWith('mailto:') ||
          href.startsWith('tel:') ||
          href.startsWith('javascript:')
      ) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch {
        return;
      }

      const isInternal =
        url.origin === window.location.origin ||
          internalDomains.includes(url.hostname);

      if (isInternal) {
        link.setAttribute('target', '_self');
        link.removeAttribute('rel');
      } else {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', updateLinks);

  // Run again for dynamically added content (AJAX, filters, apps)
  new MutationObserver(updateLinks).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

